// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-1f1f46c8] .privacy-policy-modal{max-width:720px}.title[data-v-1f1f46c8]{font-size:18px;font-weight:800}article[data-v-1f1f46c8]{max-height:480px;overflow-x:hidden;overflow-y:scroll}article[data-v-1f1f46c8] h1,article[data-v-1f1f46c8] h2,article[data-v-1f1f46c8] h3{margin:.5em 0 .25em}article[data-v-1f1f46c8] p{line-height:1.5em;margin:.75em 0 0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
